import { forwardRef, type ComponentProps } from 'react';
import { Input } from './ui';

/** Liters, one decimal (G-3). Opens the numeric keypad; the caller parses the string with parseLitersInput. */
export const LitersInput = forwardRef<HTMLInputElement, Omit<ComponentProps<'input'>, 'type'>>((props, ref) => (
  <Input ref={ref} type="text" inputMode="decimal" autoComplete="off" pattern="[0-9]*[.,]?[0-9]?" placeholder="0.0" {...props} />
));
LitersInput.displayName = 'LitersInput';

/** Birr with up to two decimals (G-2). The caller parses the string with parseBirrInput. */
export const MoneyInput = forwardRef<HTMLInputElement, Omit<ComponentProps<'input'>, 'type'>>((props, ref) => (
  <Input ref={ref} type="text" inputMode="decimal" autoComplete="off" placeholder="0.00" {...props} />
));
MoneyInput.displayName = 'MoneyInput';

export const IntInput = forwardRef<HTMLInputElement, Omit<ComponentProps<'input'>, 'type'>>((props, ref) => (
  <Input ref={ref} type="text" inputMode="numeric" autoComplete="off" pattern="[0-9]*" {...props} />
));
IntInput.displayName = 'IntInput';
